import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable, map } from 'rxjs';
import { BellNotificationGateway } from '@service/notification/bell-notification.gateway';
import { BellNotification } from '@model/notification/bell-notification.model';
import { environment } from '@env/environment';

@Injectable()
export class HttpBellNotificationAdapter extends BellNotificationGateway {
  private readonly http = inject(HttpClient);
  private readonly baseUrl = `${environment.validationResults.baseUrl}${environment.validationResults.context}/notifications`;

  getUnread(): Observable<BellNotification[]> {
    return this.http.get<BellNotification[]>(this.baseUrl);
  }

  getUnreadCount(): Observable<number> {
    return this.http.get<{ count: number }>(`${this.baseUrl}/count`).pipe(
      map((res) => res.count)
    );
  }

  markAsRead(id: string): Observable<void> {
    return this.http.patch<void>(`${this.baseUrl}/${id}/read`, {});
  }

  markAllAsRead(): Observable<void> {
    return this.http.patch<void>(`${this.baseUrl}/read-all`, {});
  }
}
